/*
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-30 13:54:49
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-06-11 20:04:36
 * @FilePath: /goldenSalesMobile/src/utils/wxpay.js
 * @Description: 微信支付方法封装(支付认证，回调)
 */
import Vue from 'vue'
import { Toast } from 'vant';
Vue.use(Toast);

/**
 * 后端支付参数多为 PascalCase（AppId/TimeStamp/...），
 * 微信 JSAPI 要求 camelCase（appId/timeStamp/...）
 */
function normalizePayParams(params = {}) {
  return {
    appId: params.appId || params.AppId,
    timeStamp: String(params.timeStamp || params.TimeStamp || ''),
    nonceStr: params.nonceStr || params.NonceStr,
    package: params.package || params.Package,
    signType: params.signType || params.SignType || 'MD5',
    paySign: params.paySign || params.PaySign,
  }
}

function onBridgeReady(params, successCallBack, failCallBack) {
  // eslint-disable-next-line no-undef
  const payParams = normalizePayParams(params)
  console.log(`88888<<<  params  >>>88888`);
  console.log(payParams);
  if (!payParams.appId) {
    Toast('支付参数缺失：appId')
    failCallBack && failCallBack()
    return
  }
  WeixinJSBridge.invoke(
    //微信支付的一些认证
    'getBrandWCPayRequest', payParams,
    function (res) {
      console.log(`99999<<<  res  >>>99999`);
      console.log(res);
      //这个是支付成功的回调
      if (res.err_msg === "get_brand_wcpay_request:ok") {
        
        successCallBack && successCallBack()
      } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
        Toast('您已取消支付')
        failCallBack && failCallBack()
      } else if (res.err_msg === 'get_brand_wcpay_request:fail') {

        failCallBack && failCallBack()
      } else {
        alert(res.err_msg)
      }
    });
}

export function getBrandWCPayRequest(params, successCallBack, failCallBack) {
  //判断typeof WeixinJSBridge是否为undefind
  console.log(`55555<<<  typeof WeixinJSBridge  >>>55555`);
  console.log(typeof WeixinJSBridge);
  const readyHandler = () => onBridgeReady(params, successCallBack, failCallBack)
  if (typeof WeixinJSBridge == "undefined"){
    // 注意：WeixinJSBridge内置对象在其他浏览器中无效。
    console.log(`77777<<<  params  >>>77777`);
    console.log(params);
    if( document.addEventListener ){
      document.addEventListener('WeixinJSBridgeReady', readyHandler, false);
    }else if (document.attachEvent){
      document.attachEvent('WeixinJSBridgeReady', readyHandler); 
      document.attachEvent('onWeixinJSBridgeReady', readyHandler);
    }
  } else {
    console.log(`66666<<<  params  >>>66666`);
    console.log(params);
    onBridgeReady(params, successCallBack, failCallBack)
  }
}
